module.exports = __webpack_public_path__ + "media/assets/images/flags/ck-64efa38287d28bdb5ca8fed582e48ee1.svg";